import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { InfrastructureType } from '../../../types/mvk_state';
import { trackInfrastructureShow } from '../../../utils/tracking';
import { cafeIcon, checkedCheckboxIcon, groceryStoresIcon, infrastructureIcon, kindergardenIcon, polyclinicsIcon, schoolIcon } from '../icons';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MVKMapInfrastructure = /*#__PURE__*/function (_React$Component) {
  _inherits(MVKMapInfrastructure, _React$Component);
  var _super = _createSuper(MVKMapInfrastructure);
  function MVKMapInfrastructure() {
    var _this;
    _classCallCheck(this, MVKMapInfrastructure);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isCollapsed: true
    });
    _defineProperty(_assertThisInitialized(_this), "handleCollapseButtonClick", function () {
      var isCollapsed = _this.state.isCollapsed;
      if (isCollapsed) {
        trackInfrastructureShow(_this.props.isOfferCard);
      }
      _this.setState({
        isCollapsed: !isCollapsed
      });
    });
    return _this;
  }
  _createClass(MVKMapInfrastructure, [{
    key: "render",
    value: function render() {
      var selected = this.props.selected;
      var isCollapsed = this.state.isCollapsed;
      return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, mergeStyles(styles['container'], isCollapsed && styles['container--collapsed'])), {}, {
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles['header'],
          children: ["\u0418\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430", /*#__PURE__*/_jsx("button", {
            className: styles['button-toggle'],
            onClick: this.handleCollapseButtonClick,
            children: infrastructureIcon
          })]
        }), /*#__PURE__*/_jsxs("ul", {
          className: styles['list'],
          children: [this.createItem(InfrastructureType.Schools, schoolIcon, 'Школы', selected.includes(InfrastructureType.Schools)), this.createItem(InfrastructureType.Kindergarden, kindergardenIcon, 'Детские сады', selected.includes(InfrastructureType.Kindergarden)), this.createItem(InfrastructureType.Polyclinics, polyclinicsIcon, 'Поликлиники', selected.includes(InfrastructureType.Polyclinics)), this.createItem(InfrastructureType.GroceryStores, groceryStoresIcon, 'Продукт. магазины', selected.includes(InfrastructureType.GroceryStores)), this.createItem(InfrastructureType.Cafes, cafeIcon, 'Кафе', selected.includes(InfrastructureType.Cafes))]
        })]
      }));
    }
  }, {
    key: "createItem",
    value: function createItem(infrastructureType, icon, title, isActive) {
      var _this2 = this;
      return /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsxs("a", _objectSpread(_objectSpread({}, mergeStyles(styles['item'], isActive && styles['item--active'])), {}, {
          onClick: function onClick() {
            return _this2.props.onSelect(infrastructureType);
          },
          children: [/*#__PURE__*/_jsxs("span", {
            children: [icon, title]
          }), /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({}, mergeStyles(styles['checkbox'], isActive && styles['checkbox--active'])), {}, {
            children: isActive && checkedCheckboxIcon
          }))]
        }))
      });
    }
  }]);
  return MVKMapInfrastructure;
}(React.Component);